<template>
  <div
    :class="{
      'sidebar-overlay-closed': !menuStore.isOpen,
      'sidebar-overlay-open': menuStore.isOpen,
    }"
  ></div>
  <aside
    v-if="!isAdmin"
    class="sidebar"
    :class="{ closed: !menuStore.isOpen, mobile: type == 's' }"
  >
    <div class="sidebar__top">
      <div class="sidebar__inner">
        <div class="sidebar__profile">
          <!--                    <div-->
          <!--                        class="sidebar__photo"-->
          <!--                        style="-->
          <!--                  background-image: url('https://www.diethelmtravel.com/wp-content/uploads/2016/04/bill-gates-wealthiest-person.jpg');-->
          <!--                "-->
          <!--                    ></div>-->
          <img
            v-show="userStore.userInfo?.imagePath"
            class="sidebar__photo"
            :src="userStore.userInfo?.imagePath"
          />
          <img
            v-show="!userStore.userInfo?.imagePath"
            class="sidebar__photo"
            id="profile_photo_blank"
            src="@/assets/images/blank_person.jpg"
          />
          <p>
            {{
              userStore.userInfo?.firstName + " " + userStore.userInfo?.lastName
            }}
          </p>
          <span>{{
            $t("profile.role." + userStore.user?.role.toLowerCase())
          }}</span>
        </div>
        <ul>
          <li>
            <router-link :to="{ name: 'profile' }">
              <div>
                <svg
                  id="perm_identity-24px_1_"
                  data-name="perm_identity-24px (1)"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.867"
                  height="27.866"
                  viewBox="0 0 27.867 27.866"
                >
                  <path
                    id="Path_495"
                    data-name="Path 495"
                    d="M0,0H27.866V27.866H0Z"
                    fill="none"
                  />
                  <path
                    id="Path_496"
                    data-name="Path 496"
                    d="M13.289,6.322a2.322,2.322,0,1,1-2.322,2.322,2.329,2.329,0,0,1,2.322-2.322m0,10.45c3.135,0,6.734,1.5,6.967,2.322v1.161H6.322V19.106c.232-.836,3.832-2.334,6.967-2.334M13.289,4a4.644,4.644,0,1,0,4.644,4.644A4.643,4.643,0,0,0,13.289,4Zm0,10.45C10.189,14.45,4,16.006,4,19.094v3.483H22.578V19.094C22.578,16.006,16.389,14.45,13.289,14.45Z"
                    transform="translate(0.644 0.644)"
                    class="fill"
                  />
                </svg>
              </div>
              <span>{{ $t("menu.my_profile") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'projects-list' }">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.9"
                  height="23.222"
                  viewBox="0 0 20.9 23.222"
                >
                  <path
                    id="Path_494"
                    data-name="Path 494"
                    d="M7.644,17.255h8.128v2.322H7.644Zm0-4.644H19.255v2.322H7.644Zm0-4.644H19.255v2.322H7.644ZM21.578,3.322H16.724a3.469,3.469,0,0,0-6.549,0H5.322a2.034,2.034,0,0,0-.464.046A2.346,2.346,0,0,0,3.186,4.75,2.237,2.237,0,0,0,3,5.644V21.9a2.382,2.382,0,0,0,.186.906,2.461,2.461,0,0,0,.5.743,2.331,2.331,0,0,0,1.173.639,3.013,3.013,0,0,0,.464.035H21.578A2.329,2.329,0,0,0,23.9,21.9V5.644A2.329,2.329,0,0,0,21.578,3.322Zm-8.128-.29a.871.871,0,1,1-.871.871A.877.877,0,0,1,13.45,3.032ZM21.578,21.9H5.322V5.644H21.578Z"
                    transform="translate(-3 -1)"
                    class="fill"
                  />
                </svg>
              </div>
              <span>{{ $t("menu.my_projects") }}</span>
            </router-link>
          </li>
          <li v-if="userStore.user.role == Role.Architect">
            <router-link :to="{ name: 'my-clients' }">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.223"
                  height="11.611"
                  viewBox="0 0 23.223 11.611"
                >
                  <path
                    id="Path_492"
                    data-name="Path 492"
                    d="M25.222,13.967H15.933V11.644h9.289Zm0-6.967H15.933V9.322h9.289ZM15.933,18.611h9.289V16.289H15.933ZM13.611,9.322v6.967a2.329,2.329,0,0,1-2.322,2.322H4.322A2.329,2.329,0,0,1,2,16.289V9.322A2.329,2.329,0,0,1,4.322,7h6.967A2.329,2.329,0,0,1,13.611,9.322Zm-1.742,6.967L9.257,12.806,7.225,15.43,5.774,13.676,3.742,16.289Z"
                    transform="translate(-2 -7)"
                    class="fill"
                  />
                </svg>
              </div>
              <span>{{ $t("menu.my_clients") }}</span>
            </router-link>
          </li>
          <!--                    <li>
                        <a href=""
                        ><div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23.223"
                                height="11.611"
                                viewBox="0 0 23.223 11.611"
                            >
                                <path
                                    id="Path_492"
                                    data-name="Path 492"
                                    d="M25.222,13.967H15.933V11.644h9.289Zm0-6.967H15.933V9.322h9.289ZM15.933,18.611h9.289V16.289H15.933ZM13.611,9.322v6.967a2.329,2.329,0,0,1-2.322,2.322H4.322A2.329,2.329,0,0,1,2,16.289V9.322A2.329,2.329,0,0,1,4.322,7h6.967A2.329,2.329,0,0,1,13.611,9.322Zm-1.742,6.967L9.257,12.806,7.225,15.43,5.774,13.676,3.742,16.289Z"
                                    transform="translate(-2 -7)"
                                    class="fill"
                                />
                            </svg>
                        </div>
                            <span>{{ $t('menu.my_inspirations') }}</span>
                        </a>
                    </li>-->
          <!--                    <li>
                        <a href=""
                        ><div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23.223"
                                height="21.307"
                                viewBox="0 0 23.223 21.307"
                            >
                                <path
                                    id="Path_488"
                                    data-name="Path 488"
                                    d="M18.836,3a6.953,6.953,0,0,0-5.225,2.427A6.953,6.953,0,0,0,8.386,3,6.324,6.324,0,0,0,2,9.386c0,4.389,3.948,7.965,9.927,13.4l1.684,1.521,1.684-1.533c5.98-5.422,9.927-9,9.927-13.387A6.324,6.324,0,0,0,18.836,3ZM13.727,21.055l-.116.116-.116-.116c-5.527-5-9.173-8.313-9.173-11.669A3.968,3.968,0,0,1,8.386,5.322a4.539,4.539,0,0,1,4.145,2.74H14.7a4.51,4.51,0,0,1,4.134-2.74A3.968,3.968,0,0,1,22.9,9.386C22.9,12.742,19.254,16.051,13.727,21.055Z"
                                    transform="translate(-2 -3)"
                                    class="fill"
                                />
                            </svg>
                        </div>
                            <span>{{ $t('menu.favourites') }}</span>
                        </a>
                    </li>-->
          <li v-if="userStore.user.role == Role.Architect">
            <router-link :to="{ name: 'finances' }">
              <div>
                <svg
                  id="account_balance_wallet-24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.867"
                  height="27.866"
                  viewBox="0 0 27.867 27.866"
                >
                  <path
                    id="Path_535"
                    data-name="Path 535"
                    d="M0,0H27.866V27.866H0Z"
                    fill="none"
                  />
                  <path
                    id="Path_536"
                    data-name="Path 536"
                    d="M23.9,7.97V5.322A2.329,2.329,0,0,0,21.578,3H5.322A2.322,2.322,0,0,0,3,5.322V21.578A2.322,2.322,0,0,0,5.322,23.9H21.578A2.329,2.329,0,0,0,23.9,21.578V18.93a2.323,2.323,0,0,0,1.161-2V9.967A2.323,2.323,0,0,0,23.9,7.97Zm-1.161,2v6.967H14.611V9.967ZM5.322,21.578V5.322H21.578V7.644H14.611a2.329,2.329,0,0,0-2.322,2.322v6.967a2.329,2.329,0,0,0,2.322,2.322h6.967v2.322Z"
                    transform="translate(0.483 0.483)"
                    class="fill"
                  />
                  <circle
                    id="Ellipse_52"
                    data-name="Ellipse 52"
                    cx="1.742"
                    cy="1.742"
                    r="1.742"
                    class="fill"
                    transform="translate(16.836 12.192)"
                  />
                </svg>
              </div>
              <span>{{ $t("menu.my_finances") }}</span>
            </router-link>
          </li>
          <!--                    <li>
                        <a href=""
                        ><div>
                            <svg
                                id="people-24px"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    id="Path_823"
                                    data-name="Path 823"
                                    d="M0,0H24V24H0Z"
                                    fill="none"
                                />
                                <path
                                    id="Path_824"
                                    data-name="Path 824"
                                    d="M9,13.75c-2.34,0-7,1.17-7,3.5V19H16V17.25C16,14.92,11.34,13.75,9,13.75ZM4.34,17A9.642,9.642,0,0,1,9,15.75,9.642,9.642,0,0,1,13.66,17ZM9,12A3.5,3.5,0,1,0,5.5,8.5,3.5,3.5,0,0,0,9,12ZM9,7A1.5,1.5,0,1,1,7.5,8.5,1.5,1.5,0,0,1,9,7Zm7.04,6.81A4.193,4.193,0,0,1,18,17.25V19h4V17.25C22,15.23,18.5,14.08,16.04,13.81ZM15,12a3.5,3.5,0,0,0,0-7,3.446,3.446,0,0,0-1.5.35,5.461,5.461,0,0,1,0,6.3A3.446,3.446,0,0,0,15,12Z"
                                    class="fill"
                                />
                            </svg>
                        </div>
                            <span>{{ $t('menu.statistics') }}</span>
                        </a>
                    </li>-->
          <!--                    <li>
                        <a href=""
                        ><div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30.998"
                                height="28.631"
                                viewBox="0 0 30.998 28.631"
                            >
                                <g
                                    id="Group_321"
                                    data-name="Group 321"
                                    transform="translate(0 -0.396)"
                                >
                                    <g
                                        id="notifications-24px_3_"
                                        data-name="notifications-24px (3)"
                                        transform="translate(0 1.161)"
                                    >
                                        <path
                                            id="Path_473"
                                            data-name="Path 473"
                                            d="M0,0H27.866V27.866H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_474"
                                            data-name="Path 474"
                                            d="M13.289,25.141a2.329,2.329,0,0,0,2.322-2.322H10.967A2.329,2.329,0,0,0,13.289,25.141Zm6.967-6.967V12.369c0-3.565-1.893-6.549-5.225-7.338v-.79a1.742,1.742,0,1,0-3.483,0v.79c-3.321.79-5.225,3.762-5.225,7.338v5.806L4,20.5v1.161H22.578V20.5Zm-2.322,1.161H8.644V12.369c0-2.88,1.753-5.225,4.644-5.225s4.644,2.345,4.644,5.225Z"
                                            transform="translate(0.644 0.403)"
                                            class="fill"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                            <span>{{ $t('menu.notifications') }}</span>
                        </a>
                    </li>-->
          <li>
            <router-link :to="{ name: 'profile-settings' }" class=""
              ><div>
                <svg
                  id="settings-24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.867"
                  height="27.866"
                  viewBox="0 0 27.867 27.866"
                >
                  <path
                    id="Path_489"
                    data-name="Path 489"
                    d="M0,0H27.866V27.866H0Z"
                    fill="none"
                  />
                  <path
                    id="Path_490"
                    data-name="Path 490"
                    d="M22.194,14.749a9.048,9.048,0,0,0,.081-1.138,9.048,9.048,0,0,0-.081-1.138l2.45-1.916a.586.586,0,0,0,.139-.743L22.461,5.8a.58.58,0,0,0-.511-.29.542.542,0,0,0-.2.035L18.862,6.7A8.483,8.483,0,0,0,16.9,5.565l-.441-3.077A.566.566,0,0,0,15.89,2H11.245a.566.566,0,0,0-.569.488l-.441,3.077A8.921,8.921,0,0,0,8.273,6.7L5.382,5.541a.657.657,0,0,0-.209-.035.575.575,0,0,0-.5.29L2.351,9.814a.572.572,0,0,0,.139.743l2.45,1.916a9.208,9.208,0,0,0-.081,1.138,9.208,9.208,0,0,0,.081,1.138l-2.45,1.916a.586.586,0,0,0-.139.743l2.322,4.017a.58.58,0,0,0,.511.29.542.542,0,0,0,.2-.035L8.273,20.52a8.483,8.483,0,0,0,1.962,1.138l.441,3.077a.566.566,0,0,0,.569.488H15.89a.566.566,0,0,0,.569-.488l.441-3.077a8.921,8.921,0,0,0,1.962-1.138l2.891,1.161a.657.657,0,0,0,.209.035.575.575,0,0,0,.5-.29l2.322-4.017a.586.586,0,0,0-.139-.743Zm-2.3-1.985a6.2,6.2,0,0,1,.058.848c0,.244-.023.5-.058.848l-.163,1.312,1.033.813,1.254.975-.813,1.4-1.475-.592-1.208-.488-1.045.79a6.8,6.8,0,0,1-1.451.848l-1.231.5-.186,1.312L14.38,22.9H12.755l-.221-1.567-.186-1.312-1.231-.5A6.588,6.588,0,0,1,9.689,18.7l-1.057-.813-1.231.5-1.475.592-.813-1.4L6.369,16.6,7.4,15.782,7.239,14.47c-.035-.36-.058-.627-.058-.859s.023-.5.058-.848L7.4,11.451l-1.033-.813L5.115,9.663l.813-1.4L7.4,8.85l1.208.488,1.045-.79A6.8,6.8,0,0,1,11.106,7.7l1.231-.5.186-1.312.232-1.567h1.614l.221,1.567L14.775,7.2l1.231.5a6.588,6.588,0,0,1,1.428.824l1.057.813,1.231-.5L21.2,8.247l.813,1.4-1.242.987-1.033.813.163,1.312Zm-6.328-3.8a4.644,4.644,0,1,0,4.644,4.644A4.643,4.643,0,0,0,13.567,8.967Zm0,6.967a2.322,2.322,0,1,1,2.322-2.322A2.329,2.329,0,0,1,13.567,15.933Z"
                    transform="translate(0.366 0.322)"
                    class="fill"
                  />
                </svg>
              </div>
              <span>{{ $t("menu.settings") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <button
        @click="menuStore.isOpen = !menuStore.isOpen"
        class="sidebar__toggler"
      >
        <img
          src="@/assets/images/menu.svg"
          alt="menu"
          width="9.449"
          height="6.299"
        />
      </button>
    </div>
    <div class="sidebar__logout">
      <ul>
        <li>
          <router-link :to="{ name: 'logout' }">
            <img
              src="@/assets/images/logout.svg"
              width="26"
              height="26"
              alt="wyloguj"
            />
            <span>{{ $t("menu.logout") }}</span>
          </router-link>
        </li>

        <li>
          <a
            class="terms-of-service"
            href="https://ewoods.pl/policies/terms-of-service"
            target="_blank"
            >{{ $t("auth.terms_of_service") }}</a
          >
        </li>
      </ul>
    </div>
  </aside>
  <aside
    v-if="isAdmin"
    class="sidebar admin-sidebar"
    :class="{ closed: !menuStore.isOpen, mobile: type == 's' }"
  >
    <div class="sidebar__top">
      <div class="sidebar__inner">
        <ul>
          <li>
            <router-link :to="{ name: 'admin.homepage' }">
              <div>
                <img src="@/assets/images/admin/home.svg" alt="Strona główna" />
              </div>
              <span> Strona główna </span>
            </router-link>
          </li>
          <li :class="{ opened: productsOpened }">
            <a @click="productsOpened = !productsOpened">
              <div>
                <img
                  src="@/assets/images/admin/photos.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.products')"
                />
              </div>
              <span>{{ $t("menu.admin.products") }}</span>
              <div class="dropdown-arrow">
                <img
                  src="@/assets/images/admin/arrow.svg"
                  width="28.893"
                  height="28.893"
                  alt=""
                />
              </div>
            </a>
            <div class="submenu">
              <ul>
                <li>
                  <router-link :to="{ name: 'admin.products.all' }">
                    <div>
                      <img
                        src="@/assets/images/admin/photos.svg"
                        width="24"
                        height="24"
                        :alt="$t('menu.admin.products')"
                      />
                    </div>
                    <span>{{ $t("menu.admin.all_products") }}</span>
                  </router-link>
                </li>
                <!--                                <li>-->
                <!--                                    <router-link :to="{name: 'admin.products.shop'}">{{ $t('menu.admin.shop_products') }}</router-link>-->
                <!--                                </li>-->
              </ul>
            </div>
          </li>
          <!--                    <li>-->
          <!--                        <a href="./profile.html"-->
          <!--                        ><div>-->
          <!--                            <img src="@/assets/images/admin/photos.svg" width="24" height="24" alt="Materiały" />-->
          <!--                        </div>-->
          <!--                            <span> Materiały </span>-->
          <!--                        </a>-->
          <!--                    </li>-->
          <li>
            <router-link :to="{ name: 'admin.orders' }">
              <div>
                <img
                  src="@/assets/images/admin/archive.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.orders')"
                />
              </div>

              <span>{{ $t("menu.admin.orders") }}</span>
            </router-link>
          </li>
          <!--                    <li>-->
          <!--                        <a href="./profile.html"-->
          <!--                        ><div>-->
          <!--                            <img src="@/assets/images/admin/archive.svg" width="24" height="24" alt="Logistyka" />-->
          <!--                        </div>-->
          <!--                            <span> Logistyka </span>-->
          <!--                        </a>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <a href="./profile.html"-->
          <!--                        ><div>-->
          <!--                            <img src="@/assets/images/admin/archive.svg" width="24" height="24" alt="Analiza danych" />-->
          <!--                        </div>-->
          <!--                            <span> Analiza danych </span>-->
          <!--                        </a>-->
          <!--                    </li>-->
          <li :class="{ opened: adminUsersOpened }">
            <a @click="adminUsersOpened = !adminUsersOpened">
              <div>
                <img
                  src="@/assets/images/admin/people.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.users')"
                />
              </div>
              <span>{{ $t("menu.admin.users") }}</span>
              <div class="dropdown-arrow">
                <img
                  src="@/assets/images/admin/arrow.svg"
                  width="28.893"
                  height="28.893"
                  :alt="$t('menu.admin.users')"
                />
              </div>
            </a>
            <div class="submenu">
              <ul>
                <li>
                  <router-link
                    :to="{
                      name: 'admin.users.ewoods',
                      params: { role: 'admin' },
                    }"
                    >{{ $t("menu.admin.users_ewoods") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'admin.users.ewoods',
                      params: { role: 'architect' },
                    }"
                    >{{ $t("menu.admin.users_architect") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'admin.users.ewoods',
                      params: { role: 'client' },
                    }"
                    >{{ $t("menu.admin.users_client") }}</router-link
                  >
                </li>
              </ul>
            </div>
          </li>
          <li>
            <router-link :to="{ name: 'admin.producers' }">
              <div>
                <img
                  src="@/assets/images/admin/people.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.producers')"
                />
              </div>
              <span>{{ $t("menu.admin.producers") }}</span>
            </router-link>
          </li>
          <!--                    <li>-->
          <!--                        <a href="./profile.html"-->
          <!--                        ><div>-->
          <!--                            <img src="@/assets/images/admin/settings.svg" width="24" height="24" alt="Ustawienia" />-->
          <!--                        </div>-->
          <!--                            <span> Ustawienia </span>-->
          <!--                        </a>-->
          <!--                    </li>-->

          <li>
            <router-link :to="{ name: 'admin.finance' }">
              <div>
                <img
                  src="@/assets/icons/admin/finance.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.finance')"
                />
              </div>
              <span>{{ $t("menu.admin.finance") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'admin.style-quiz' }">
              <div>
                <img
                  src="@/assets/images/admin/settings.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.style_quiz')"
                />
              </div>
              <span>{{ $t("menu.admin.style_quiz") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'admin.style-quiz-steps' }">
              <div>
                <img
                  src="@/assets/icons/admin/layers.svg"
                  width="24"
                  height="24"
                  :alt="$t('menu.admin.style_quiz_steps')"
                />
              </div>
              <span>{{ $t("menu.admin.style_quiz_steps") }}</span>
            </router-link>
          </li>
          <li class="profile-menu">
            <router-link :to="{ name: 'admin.profile' }" class="">
              <div>
                <img src="@/assets/icons/admin/profile.svg" alt="Twój profil" />
              </div>
              {{ $t("admin.general.your_profile") }}
            </router-link>
          </li>
          <li class="profile-menu">
            <router-link :to="{ name: 'admin.settings' }" class="">
              <div>
                <img
                  src="@/assets/icons/admin/settings-black.svg"
                  alt="Ustawienia"
                />
              </div>
              {{ $t("admin.general.settings") }}
            </router-link>
          </li>
          <li class="profile-menu">
            <router-link :to="{ name: 'logout' }">
              <div>
                <img
                  src="@/assets/icons/admin/logout.svg"
                  :alt="$t('admin.general.logout')"
                />
              </div>
              <span>{{ $t("admin.general.logout") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <button
        class="sidebar__toggler"
        @click="menuStore.isOpen = !menuStore.isOpen"
      >
        <img
          src="@/assets/images/menu.svg"
          alt="menu"
          width="9.449"
          height="6.299"
        />
      </button>
    </div>
  </aside>
</template>

<script>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth.store";
import router from "@/router";
import { Role } from "@/helpsers/role.helper";
import breakpointsHelper from "@/helpsers/breakpoints.helper";
import { useMenuStore } from "@/stores/menu.store";

export default {
  name: "Menu",
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const menuStore = useMenuStore();
    const userStore = useAuthStore();

    //Pobieranie rozmiaru ekranu.
    const { width, type } = breakpointsHelper();

    let productsOpened = ref(false);
    if (router?.currentRoute?.value?.meta?.parent === "admin.products")
      productsOpened.value = true;
    let adminUsersOpened = ref(false);
    if (router?.currentRoute?.value?.meta?.parent === "admin.users")
      adminUsersOpened.value = true;

    router.beforeEach(() => {
      if (type.value == "s" || type.value == "xs") {
        menuStore.isOpen = true;
      }
    });

    return {
      userStore,
      menuStore,
      productsOpened,
      adminUsersOpened,
      Role,
      type,
    };
  },
};
</script>

<style>
@media screen and (max-width: 767px) {
  .header--admin .header__right .header__name:hover .header__name-list {
    display: none !important;
  }
}
</style>

<style scoped lang="scss">
.sidebar__photo {
  display: flex;
  object-fit: cover;
}

.admin-sidebar {
  &.closed {
    .submenu {
      padding: 0 0 0 38px;

      li {
        a.router-link-active {
          padding-left: 0;
        }
      }
    }
  }

  ul li a {
    &.router-link-active {
      color: #ad6f69;
      background-color: transparent;
      border-left: none;
    }

    &:hover {
      color: #ad6f69;
    }
  }

  .sidebar__toggler {
    background-color: #ad6f69;
  }

  .profile-menu {
    display: none;

    @media screen and (max-width: 767px) {
      display: block;
    }

    img {
      width: 24px;
    }
  }
}
.terms-of-service {
  text-decoration: underline;
}
</style>
